import React, { useState, useEffect, useContext, ChangeEvent, useRef } from "react";
import {
  Layout,
  Tabs,
  Form,
  Input,
  Select,
  Button,
  message,
  Row,
  Col,
  Typography,
  Spin,
  Divider,
  Space,
  Table,
  Modal,
  List,
  TableProps,
  AutoComplete,
} from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { CompanyCode } from "../../core/interfaces/CompanyCode";
import {
  FetchCompany,
  fetchCompanyCodes,
  fetchEmpDetails,
  fetchReportCodes,
  FetchReviewUsers,
  FetchSubsidiariesByObject,
  SaveAccApprovalRequest,
  SaveAccAttachment,
  SaveACCRequest,
  SaveACCRequestDetails
} from "../../core/services/account-request.service";
import { ReportCode } from "../../core/interfaces/ReportCode";
import { UserContext } from "../../context/user-context";
import { useNavigate } from "react-router-dom";
import { Employee } from "../../core/interfaces/Employee";
import { valueType } from "antd/es/statistic/utils";
import { Approval } from "../../core/interfaces/Approval";
import { CalClient } from '@cvx/cal';
import { environment } from "../../../src/environments/environment"
import { User } from "../../../src/core/interfaces/User"
import { ReqStatus } from "../../core/interfaces/ReqStatus";
import { AccRequestData } from "../../core/interfaces/AccRequestData";
import { AccReqFormValues } from "../../core/interfaces/AccReqFormValues";
import { appInsights } from "../../core/services/insight.service";
import TextArea from "antd/es/input/TextArea";
import GlobalErrorMessage from "../global-error/GlobalErrorMessage";
import { fetchAccountObjectsData } from "../../core/services/administration.service";
import { JdCompany } from "../../core/interfaces/JdCompany";

const { TabPane } = Tabs;
const { Option } = Select;
const { Title } = Typography;
interface DropdownOption {
  value: string;
  label: string;
}
type UploadStatus = 'idle' | 'uploading' | 'success' |'error';
const AccRequest: React.FC = () => {
  const [requester, setRequester] = useState<string>("");
  const [accountrequests, setAccountRequest] = useState<AccRequestData[]>([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedUser, setSelectedUser] = useState<string | null>(null);
  const [open,setOpen] = useState(false);
  const [empData, setEmpData] = useState<Employee[]>([]);
  const [totalSteps] = useState(5);
  const [isHelpVisible, setIsHelpVisible] = useState(false);
  const [requestDate, setRequestDate] = useState<string>(new Date().toLocaleDateString());
  const [reason, setReason] = useState<string>("");
  const [company, setCompany] = useState<Number>(0);
  const [actionCode, setActionCode] = useState<string>("A");
  const [postEdit, setPostEdit] = useState<string>("");
  const [AccType, setAccType] = useState<string>("");
  const [Acc, setAcc] = useState<ReportCode[]>([]);
  const [companyCodes, setCompanyCodes] = useState<CompanyCode[]>([]);
  const [companyCode, setCompanyCode] = useState<JdCompany>({} as JdCompany);
  const [buModified, setBuModified] = useState<number | 1>(1);
  const contextUser = React.useContext(UserContext);
  const [loading, setLoading] = useState(true);
  const [currentTab, setCurrentTab] = useState<number | 1>(1);
  const [management2, setManagement2] = useState<ReportCode[]>([]);
  const [management2Type, setmanagment2Type] = useState<string>("");
  const [management3, setManagement] = useState<ReportCode[]>([]);
  const [management3Type, setmanagment3Type] = useState<string>("");
  const [jcprocesses, setjcprocesses] = useState<ReportCode[]>([]);
  const [jcprocessestype, setjcprocessestype] = useState<string>("");
  const [jccomponentstype, setjccomponentstype] = useState<string>("");
  const [jccomponents, setjccomponents] = useState<ReportCode[]>([]);
  const [jcdiswintype, setjcdiswintype] = useState<string>("");
  const [jcdiswin, setjcdiswin] = useState<ReportCode[]>([]);
  const [jcintangibletype, setjcintangibletype] = useState<string>("");
  const [jcintangible, setjcintangible] = useState<ReportCode[]>([]);
  const [gareportingtype, setgareportingtype] = useState<string>("");
  const [gareporting, setgareporting] = useState<ReportCode[]>([]);
  const [jvpostingtype, setjvpostingtype] = useState<string>("");
  const [jvposting, setjvposting] = useState<ReportCode[]>([]);
  const [division, setDivision] = useState<ReportCode[]>([]);
  const [divisionType, setdivisionType] = useState<string>("");
  const [partnertype, setpartnertype] = useState<string>("");
  const [partner, setpartner] = useState<ReportCode[]>([]);
  const [management1type, setmanagement1type] = useState<string>("");
  const [management1, setmanagement1] = useState<ReportCode[]>([]);
  const [currencytype, setcurrencytype] = useState<string>("");
  const [currency, setcurrency] = useState<ReportCode[]>([]);
  const [currencyrestate2type, setcurrencyrestate2type] = useState<string>("");
  const [currencyrestate2, setcurrencyrestate2] = useState<ReportCode[]>([]);
  const [currencyrestate3type, setcurrencyrestate3type] = useState<string>("");
  const [currencyrestate3, setcurrencyrestate3] = useState<ReportCode[]>([]);
  const [Alternatetype, setAlternatetype] = useState<string>("");
  const [Alternate, setAlternate] = useState<ReportCode[]>([]);
  const [Aribatype, setAribatype] = useState<string>("");
  const [Ariba, setAriba] = useState<ReportCode[]>([]);
  const [SAPtype, setSAPtype] = useState<string>("");
  const [SAP, setSAP] = useState<ReportCode[]>([]);
  const [Tax1type, setTax1type] = useState<string>("");
  const [Tax1, setTax1] = useState<ReportCode[]>([]);
  const [Tax2type, setTax2type] = useState<string>("");
  const [Tax2, setTax2] = useState<ReportCode[]>([]);
  const [Tax3type, setTax3type] = useState<string>("");
  const [Tax3, setTax3] = useState<ReportCode[]>([]);
  const [psccodetype, setpsccodetype] = useState<string>("");
  const [psccode, setpsccode] = useState<ReportCode[]>([]);
  const [Recontype, setRecontype] = useState<string>("");
  const [Recon, setRecon] = useState<ReportCode[]>([]);
  const [ReconRestype, setReconRestype] = useState<string>("");
  const [ReconRes, setReconRes] = useState<ReportCode[]>([]);
  const [PartnerReqtype, setPartnerReqtype] = useState<string>("");
  const [PartnerReq, setPartnerReq] = useState<ReportCode[]>([]);
  const [Localization3Type, setLocalization3Type] = useState<string>("");
  const [Localization3, setLocalization3] = useState<ReportCode[]>([]);
  const [jvChargeability, setjvChargeability] = useState<ReportCode[]>([]);
  const [jvChargeabilityType, setjvChargeabilityType] = useState<string>("");
  const [jvCode, setjvCode] = useState<ReportCode[]>([]);
  const [businessActivity, setbusinessActivity] = useState<ReportCode[]>([]);
  const [interfaceControl1, setinterfaceControl1] = useState<ReportCode[]>([]);
  const [interfaceControl1TYpe, setinterfaceControl1TYpe] = useState<string>("");
  const [interfaceControl2, setinterfaceControl2] = useState<ReportCode[]>([]);
  const [interfaceControl2Type, setinterfaceControl2Type] = useState<string>("");
  const [Localization1, setLocalization1] = useState<ReportCode[]>([]);
  const [Localization1Type, setLocalization1Type] = useState<string>("");
  const [Localization2, setLocalization2] = useState<ReportCode[]>([]);
  const [Localization2Type, setLocalization2Type] = useState<string>("");
  const [approvers, setApprovers] = useState<Approval[]>([]); 
  const [faApprovers, setfaApprovers] = useState<Approval[]>([]);
  const [faApproversType, setfaApproversType] = useState<string>("");
  const [jvApprovers, setjvApprovers] = useState<Approval[]>([]);
  const [selectedjvApprovers, setselectedjvApprovers] = useState<string>("");
  const [pscApprovers, setpscApprovers] = useState<Approval[]>([]);
  const [selectedpscApprovers, setSelectedpscApprovers] = useState<string>("");
  const [gasApprovers, setgasApprovers] = useState<Approval[]>([]);
  const [selectedgasApprovers, setselectedgasApprovers] = useState<string>("");
  const [interCoApprovers, setinterCoApprovers] = useState<Approval[]>([]);
  const [selectedinterCoApprovers, setselectedinterCoApprovers] = useState<string>("");
  const [allocationapprovers, setallocationapprovers] = useState<Approval[]>([]);
  const [selectedallocationapprovers, setselectedallocationapprovers] = useState<string>("");
  const [fixedAssetapprovers, setfixedAssetapprovers] = useState<Approval[]>([]);
  const [selectedfixedAssetapprovers, setselectedfixedAssetapprovers] = useState<string>("");
  const [productionAccountingapprovers, setproductionAccountingapprovers] = useState<Approval[]>([]);
  const [selectedproductionAccountingapprovers, setselectedproductionAccountingapprovers] = useState<string>("");
  const [aCCRequestResponse, setAccRequestResponse] = React.useState<AccReqFormValues>({} as AccReqFormValues); 
  const [aCCRequestDetailsResponse, setAccRequestDetailsResponse] = React.useState<AccReqFormValues>({} as AccReqFormValues); 
  const [aCCApprovalResponse, setAccApprovalResponse] = React.useState<AccReqFormValues>({} as AccReqFormValues);  
  const [formrequest] = Form.useForm<AccReqFormValues>();
  const [formrapproval] = Form.useForm<AccReqFormValues>();
  const [employeeDept, setEmployeeDept] = useState<string>("");
  const [file1, setFile1] = useState<File | null>(null);
  const [file2, setFile2] = useState<File | null>(null);
  const [file3, setFile3] = useState<File | null>(null);
  const [status, setStatus] = useState<UploadStatus>('idle');
  const [subsidiaries, setSubsidiaries] = useState<AccRequestData[]>([]); 
  const [accountName, setAccountName] = useState<AccRequestData[]>([]); 
  const [graphUser, setGraphUser] = useState<User>({});
  const [filteredObjectOptions, setFilteredObjectOptions] = useState<{ key: string; value: string }[]>([]);
  const [autoCompleteOptions, setAutoCompleteOptions] = useState<{ key: string; value: string }[]>([]);
  const [selectedRequesterName, setSelectedRequesterName] = useState<string>("");
  const cal = new CalClient(environment.calConfig);
  const user = useContext(UserContext);
  const getUserEmail = async () => {
    try {
      const response = await cal.getUserPropertiesFromMsGraph([
        "userPrincipalName"
      ]);
      setGraphUser((prev) => ({ ...prev, ...user }));
      setGraphUser((prev) => ({ ...prev, Emaild: response.userPrincipalName }));
      appInsights.trackEvent({
        name: "Get User Email Success",
        properties: { userId: user.email },
      });
    } catch (error) {
      setApiError(error);
      message.error("Failed to get user email");
      appInsights.trackException({
        exception: error as Error,
        properties: {
          Component: "AccountRequest",
          method: "getUserEmail",
          context: "Get User Email",
          userId: user.email,
        },
      });
    }
  };
  const [jvdeatils, setjvdeatils] = useState<string>("");
  const [pscDetails,setpscDetails] = useState<string>("");
  const [bpcDetails,setbpcDetails] = useState<string>("");
  const [alloDetails,setalloDetails] = useState<string>("");
  const [prodDetails,setprodDetails] = useState<string>("");
  const [interDetails,setinterDetails] = useState<string>("");
  const [fixDetails,setfixDetails]= useState<string>("");
  const [gasDetails,setgasDetails] = useState<string>("");
  const [issucess, setIssucess] = useState<boolean>(false);
  const [apiError, setApiError] = useState(null);
  const navigate = useNavigate();
  const effectRan = useRef(false);
  const userProfile = useContext(UserContext);
  useEffect(() => {
    const initializeData = async () => {
      try {
        setLoading(true);
        setSubsidiaries([]);
        await getUserEmail();
        await fetchCompanyCodesData();
        await fetchBusinessReportCodes();
        await fetchAllReportCodes();
        await fetchAccountObjects();

    if (contextUser.email) {
      setRequester(contextUser.email);
    }
    const initialAccountRequest = [
        {
          key: 1,
          accountName: "",
          businessUnit:"" ,
          object: "",
          subsidiary: "",
          objDescription: "",
          subDescription: "",
        },
    ];
    setAccountRequest(initialAccountRequest);
    const SearchUser = async () => {
      setLoading(true);
      try {
          const response = await fetchEmpDetails(graphUser.email ?? ""); // Adjust the API endpoint as needed
          if (response && response.length > 0) {
              const employee = response[0];
              setEmployeeDept(employee.deptName); // Get the department name from the API response
          }
          else
          {
          } 
        }
        catch (error) {
          setApiError(error);
      } finally {
      }  
    };
     const approversData = await FetchReviewUsers(userProfile);
           setApprovers(approversData);
           // Filter approvers by groups
           setfaApprovers(approversData.filter((a) => a.appgroup === 1));
           setjvApprovers(approversData.filter((a) => a.appgroup === 2));
           setpscApprovers(approversData.filter((a) => a.appgroup === 3));
           setgasApprovers(approversData.filter((a) => a.appgroup === 4));
           setinterCoApprovers(approversData.filter((a) => a.appgroup === 5));
           setallocationapprovers(approversData.filter((a) => a.appgroup === 6));
           setproductionAccountingapprovers(approversData.filter((a) => a.appgroup === 8));
           setfixedAssetapprovers(approversData.filter((a) => a.appgroup === 9));
          } catch (error) {
            setApiError(error);
            console.error("Error initializing data:", error);
          } finally {
            setLoading(false);
          }
        };
        if (effectRan.current === false) {
          initializeData();
        effectRan.current = true;
      }
      }, [contextUser]);
  const buModifiedOptions: JSX.Element[] = [];
  let x = 0;
  while (x < 20) {
    buModifiedOptions.push(
      <option key={x + 1} value={x + 1}>
        {x + 1}
      </option>
    );
    x = x + 1;
  }
  const handleChange = (value: number) => {
    setBuModified(value);
    const updatedBusinessUnits = Array.from({ length: value }, (_, index) => ({
      key: index + 1,
      accountName: "",
      businessUnit: "",
      object: "",
      subsidiary: "",
      objDescription: "",
      subDescription: "",
    }));
    setAccountRequest(updatedBusinessUnits);
  };
  const fetchAccountObjects = async () => {
    try {
      const response = await fetchAccountObjectsData(userProfile); // Replace with your API call
      const options = response.map((item, index) => ({
        key: `${item.objectId}-${index}`,
        value: `${item.object} - ${item.objDescription}`,
      }));
      setAutoCompleteOptions(options); // Update the state with the fetched options
      appInsights.trackEvent({
        name: "Fetch Account Objects Success",
        properties: { userId: user.email },
      });
    } catch (error) {
      setApiError(error);
      message.error("Failed to fetch account objects");
      appInsights.trackException({
        exception: error as Error,
        properties: {
          Component: "AccountRequest",
          method: "fetchAccountObjectsData",
          context: "Fetch Account Objects",
          userId: user.email,
        },
      });
    }
  };

  const fetchCompanyCodesData = async () => {
    setLoading(true);
    try {
      let data = await fetchCompanyCodes(userProfile);
      setCompanyCodes(data);
      appInsights.trackEvent({ name: "Fetch Company Codes Success", properties: { userId: user.email } });
    } catch (error) {
      setApiError(error);
      message.error("Failed to fetch Company Codes");
      appInsights.trackException({ exception: error as Error, properties: { Component: 'AccountRequest', method: 'fetchCompanyCodesData', context: 'Fetch Company Codes', userId: user.email } });
    }
    finally {
      setLoading(false);
    }
  };
  const fetchBusinessReportCodes = async () => {
    setLoading(true);
    // Define all the types you want to fetch
    const types = [
      { drsy: "00", drrt: "UM", type: "Unit of Measure" },
    ]
    try {
      const response = await fetchReportCodes("00","'UM'"); // Adjust the API endpoint as needed
      for (const type of types) {
        const matchingData = response.filter((item: ReportCode) => item.drrt === type.drrt);
        if (matchingData.length > 0) {
          switch (type.type) {
        case "Unit of Measure":
          setAcc(matchingData);
          break;
        default:
          break;
        }
      }
    }
  } catch (error) {
    setApiError(error);
    console.error("Error fetching report codes:", error);
  }
}
  const fetchAllReportCodes = async () => {
    setLoading(true);
    // Define all the types you want to fetch
    const types = [
      { drsy: "09", drrt: "01", type: "JC_PROCESS" },
      { drsy: "09", drrt: "02", type: "JC_COMPONENTS" },
      { drsy: "09", drrt: "03", type: "JC_DISWIN" },
      { drsy: "09", drrt: "04", type: "JC_INTANGIBLE" },
      { drsy: "09", drrt: "05", type: "Interface-Control_1" },
      { drsy: "09", drrt: "06", type: "Interface-Control_2" },
      { drsy: "09", drrt: "07", type: "Management_Report_2" },
      { drsy: "09", drrt: "08", type: "Management_Report_3" },
      { drsy: "09", drrt: "09", type: "GA_REPORTING" },
      { drsy: "09", drrt: "10", type: "JV_POSTING" },
      { drsy: "09", drrt: "11", type: "JVChargeability" },
      { drsy: "09", drrt: "12", type: "Division" },
      { drsy: "09", drrt: "13", type: "Partner" },
      { drsy: "09", drrt: "14", type: "mangement1" },
      { drsy: "09", drrt: "15", type: "localization1" },
      { drsy: "09", drrt: "16", type: "currency" },
      { drsy: "09", drrt: "17", type: "currencyrestate2" },
      { drsy: "09", drrt: "18", type: "curencyrestate3" },
      { drsy: "09", drrt: "19", type: "localization2" },
      { drsy: "09", drrt: "20", type: "localization3" },
      { drsy: "09", drrt: "21", type: "Alternative" },
      { drsy: "09", drrt: "22", type: "Ariba" },
      { drsy: "09", drrt: "23", type: "SAP" },
      { drsy: "09", drrt: "24", type: "Tax1" },
      { drsy: "09", drrt: "25", type: "Tax2" },
      { drsy: "09", drrt: "26", type: "Tax3" },
      { drsy: "09", drrt: "27", type: "PSCcode" },
      { drsy: "09", drrt: "28", type: "Recon" },
      { drsy: "09", drrt: "29", type: "ReconRes" },
      { drsy: "09", drrt: "30", type: "PartnerReq" },
    ];
    try {
        const commaSeparated = types.map(obj => `'${obj.drrt}'`).join(',');
        const response = await fetchReportCodes("09",commaSeparated); // Adjust the API endpoint as needed
        for (const type of types) {
          const matchingData = response.filter((item: ReportCode) => item.drrt === type.drrt);
          if (matchingData.length > 0) {
            switch (type.type) {
              case "JC_PROCESS":
                setjcprocesses(matchingData);
                break;
              case "JC_COMPONENTS":
                setjccomponents(matchingData);
                break;
              case "JC_DISWIN":
                setjcdiswin(matchingData);
                break;
              case "JC_INTANGIBLE":
                setjcintangible(matchingData);
                break;
              case "Interface-Control_1":
                setinterfaceControl1(matchingData);
                break;
              case "Interface-Control_2":
                setinterfaceControl2(matchingData);
                break;
              case "Management_Report_2":
                setManagement2(matchingData);
                break;
              case "Management_Report_3":
                setManagement(matchingData);
                break;
              case "GA_REPORTING":
                setgareporting(matchingData);
                break;
              case "JV_POSTING":
                setjvposting(matchingData);
                break;
              case "JVChargeability":
                setjvChargeability(matchingData);
                break;
              case "Division":
                setDivision(matchingData);
                break;
              case "Partner":
                setpartner(matchingData);
                break;
              case "mangement1":
                setmanagement1(matchingData);
                break;
              case "localization1":
                setLocalization1(matchingData);
                break;
              case "currency":
                setcurrency(matchingData);
                break;
              case "currencyrestate2":
                setcurrencyrestate2(matchingData);
                break;
              case "curencyrestate3":
                setcurrencyrestate3(matchingData);
                break;
              case "localization2":
                setLocalization2(matchingData);
                break;
              case "localization3":
                setLocalization3(matchingData);
                break;
              case "Alternative":
                setAlternate(matchingData);
                break;
              case "Ariba":
                setAriba(matchingData);
                break;
              case "SAP":
                setSAP(matchingData);
                break;
              case "Tax1":
                setTax1(matchingData);
                break;
              case "Tax2":
                setTax2(matchingData);
                break;
              case "Tax3":
                setTax3(matchingData);
                break;
              case "PSCcode":
                setpsccode(matchingData);
                break;
              case "Recon":
                setRecon(matchingData);
                break;
              case "ReconRes":
                setReconRes(matchingData);
                break;
              case "PartnerReq":
                setPartnerReq(matchingData);
                break;
              default:
                break;
          }
        }
      }
    } catch (error) {
      setApiError(error);
      console.error("Error fetching report codes:", error);
    } finally {
      setLoading(false);
    }
  };
  const handleCancel = () => {
    setIsModalVisible(true);
  }
  const handlecancel = () => {
    setIsModalVisible(false);
  };
  const handleok = () => {
    setIsModalVisible(false);
    navigate("/home");
  };

  const handleBack = () => {
    setCurrentTab((prev) => Math.max(prev - 1, 1));
  };

  const handleNext = async () => {
  if(currentTab === 2)
  {
    setIsHelpVisible(true);
    if(currencytype !== "")
    {
      setIsHelpVisible(false);
    }
  }
  if(currentTab === 3)
  {
    if(currencytype !== "")
    {
      setIsHelpVisible(false);
    }
  }

  setCurrentTab((prev) => Math.min(prev + 1, 6));
  };
  const SetCompanyCode = async (e: any) => {
    setLoading(true);
    try {
      const response = await FetchCompany(e); // Ensure FetchCompany returns an array
      setCompanyCode(response); // Ensure response is an array of BusinessUnit
      appInsights.trackEvent({ name: "Fetch Company Success", properties: { userId: user.email, companyCode: e } });
    } catch (error) {
      setApiError(error);
      console.error(error);
      setCompanyCode({} as JdCompany); // Reset to an empty array on error
      appInsights.trackException({ exception: error as Error, properties: { Component: 'AccountRequest', method: 'SetCompanyCode', context: 'Fetch Company', userId: user.email, companyCode: e } });
    } finally {
      setLoading(false);
    }
  };

  function handleFileChange1(e: ChangeEvent<HTMLInputElement>)
  {
    if(e.target.files)
    {
      setFile1(e.target.files[0]);
    }
  }
  function handleFileChange2(e: ChangeEvent<HTMLInputElement>)
  {
    if(e.target.files)
    {
      setFile2(e.target.files[0]);
    }
  }
  function handleFileChange3(e: ChangeEvent<HTMLInputElement>)
  {
    if(e.target.files)
    {
      setFile3(e.target.files[0]);
    }
  }

  const handleFinish =  async () => {
    setLoading(true);
    if(currentTab === 5)
    {
      if(selectedUser === "")
      {
        message.error("approverEmail is required");
        appInsights.trackEvent({ name: "Validation Error", properties: { userId: user.email, message: "approverEmail is required" } });
      }
      if(faApproversType === "")
      {
        message.error("FaApprovers is required");
        appInsights.trackEvent({ name: "Validation Error", properties: { userId: user.email, message: "FaApprovers is required" } });
      }
    }
    const AccRequestData: AccReqFormValues = {
      Requester: graphUser.email,
      RequestDate: new Date(),
      ActioncCode: actionCode,
      Company: company.toString(),
      Reason: reason,
      PostEdit: postEdit,
      UOM : AccType,
      RC1: jcprocessestype,
      RC2: jccomponentstype,
      RC3: jcdiswintype,
      RC4:jcintangibletype,
      RC5:interfaceControl1TYpe,
      RC6:interfaceControl2Type,
      RC7:management2Type,
      RC8:management3Type,
      RC9:gareportingtype,
      RC10:jvpostingtype,
      RC11:jvChargeabilityType,
      RC12:divisionType,
      RC13:partnertype,
      RC14:management1type,
      RC15:Localization1Type,
      RC16:currencytype,
      RC17:currencyrestate2type,
      RC18:currencyrestate3type,
      RC19:Localization2Type,
      RC20:Localization3Type,
      RC21:Alternatetype,
      RC22:Aribatype,
      RC23:SAPtype,
      RC24:Tax1type,
      RC25:Tax2type,
      RC26:Tax3type,
      RC27:psccodetype,
      RC28:Recontype,
      RC29:ReconRestype,
      RC30:PartnerReqtype,
      RequesterName: graphUser.email,
      RequesterDept: employeeDept || "UNKNOWN",
      Attachmnt1: file1?.name || "",
      Attachmnt2: file2?.name || "",
      Attachmnt3: file3?.name || "",
    }
      const accrequestresponse = await SaveACCRequest(AccRequestData); 
      sessionStorage.setItem("AccRequestID", accrequestresponse.requestID?.toString() || "");
      const storedRequestID = sessionStorage.getItem("AccRequestID");
      setStatus("uploading");
      const fileDataArray = [
        { file: file1, key: "file1" },
        { file: file2, key: "file1" },
        { file: file3, key: "file1" },
      ];
      for (const fileData of fileDataArray) {
        if (fileData.file) {
          const formData = new FormData();
          if (storedRequestID) {
            formData.append("requestid", storedRequestID);
          }
          formData.append(fileData.key, fileData.file);
      
          const formValues = Object.fromEntries(formData);
          try {
            await SaveAccAttachment(formValues);
          } catch (error) {
            setApiError(error);
            console.error(`Failed to upload ${fileData.key}:`, error);
          }
        }
      }
      const accRequestDetailsData: AccReqFormValues = {
        requestID: storedRequestID ? parseInt(storedRequestID, 10) : undefined,
        AcctName: accountName.map((subsidiary) => subsidiary.object === subsidiary.object ? subsidiary.objDescription : "").toString(),
        Ccenter: companyCode.locationCode.toString() + "" + accountrequests.map((unit) => unit.businessUnit).join(","),
        AcctObj: accountrequests.map((unit) => unit.object).join(","),
        Subsidiary: accountrequests.map((unit) => unit.subsidiary).join(","),
        Done: "N",
      }
      const accrequestdetailsresponse = await SaveACCRequestDetails(accRequestDetailsData);
      const reqStatus: ReqStatus = ReqStatus.PendingApprovalByLine;
      const accRequestApprovalData: AccReqFormValues = {
        requestID: storedRequestID ? parseInt(storedRequestID, 10) : undefined,
        Line: selectedUser ||"",
        LineDate: new Date(),
        LineAppr: "N",
        LineComments: "",
        FA: faApproversType,
        FADate:new Date(),
        FAAppr: "N",
        FAExm: "",
        FAComments: "",
        JV: selectedjvApprovers,
        JVDate:new Date(),
        JVAppr: "N",
        JVEXM: jvdeatils,
        JVComments: "",
        PSC: selectedpscApprovers,
        PSCDate:new Date(),
        PSCAppr: "N",
        PSCEXM: pscDetails,
        PSCComments: "",
        GAS: selectedgasApprovers,
        GASDate:new Date(),
        GASAppr: "N",
        GASEXM: gasDetails,
        GASComments: "",
        INTER: selectedinterCoApprovers,
        INTERDate:new Date(),
        INTERAppr: "N",
        INTEREXM: interDetails,
        INTERComments: "",
        ALLO: selectedallocationapprovers,
        ALLODate:new Date(),
        ALLOAppr: "N",
        ALLOEXM: alloDetails,
        ALLOComments: "",
        COMP: "l9lek513",
        COMPDate:new Date(),
        COMPAppr: "N",
        COMPComments: "",
        FixAss: selectedfixedAssetapprovers,
        FIXASSDate:new Date(),
        FIXASSAppr: "N",
        FIXASSEXM: alloDetails,
        FIXASSComments: "",
        PROD: selectedproductionAccountingapprovers,
        PRODDate:new Date(),
        PRODAppr: "N",
        PRODEXM: alloDetails,
        PRODComments: "",
        STATUS: reqStatus,
        PENDINGON: selectedUser || "",
        URL: "AccRequestDetails.aspx?requestNumber=" + "" + storedRequestID,
        UPDATEDBY: graphUser.email,
        UPDATEDATE: new Date(),
        HasReroute: "N",
      } 
      const accrequestapprovalresponse = await SaveAccApprovalRequest(accRequestApprovalData); 
      setAccRequestResponse(accrequestresponse);
      setAccRequestDetailsResponse(accrequestdetailsresponse);
      setAccApprovalResponse(accrequestapprovalresponse);
      setLoading(false);
      setIssucess(true);
      setTimeout(() => {
        setIssucess(false);
        navigate("/home");
      }, 10000); // Redirect after 5 seconds
      appInsights.trackEvent({ name: "Save Account Request Success", properties: { userId: user.email, requestID: storedRequestID } });
  };
  const handleclose = () =>  {
    navigate("/home");
  }
  const onSelectedSubsidiaryChange = async (value: string) => {
    const response = await FetchSubsidiariesByObject(value);
    setSubsidiaries(response);
  }
const setRequesters = (text:string) => {
    setSelectedRequesterName(text);
    setSelectedUser(text);
    setOpen(false);
    setEmpData([]);
 }
 const showModal = async(e: any) => {
  setSelectedUser(e);
  setOpen(true);
  if (e && e.trim() !== "") {
    await SearchUser(e);
  } else {
    setEmpData([]);
  }
};
 const SearchUser = async(text:any) => {
    setLoading(true);
    try {
        const response = await fetchEmpDetails(text); // Adjust the API endpoint as needed
        setEmpData(response);
        appInsights.trackEvent({ name: "Search User Success", properties: { userId: user.email, searchText: text } });
      } catch (error) {
        setApiError(error);
        message.error("Failed to fetch users");
        appInsights.trackException({ exception: error as Error, properties: { Component:'ReviewSetup', method:'SearchUser', context: 'Search User', userId: user.email, searchText: text } }); // Track exception
      } finally {
        setLoading(false);
      }  
};
const handleOk = async(e: any) =>  {
  setOpen(false);
  }

  const handleempCancel = async(e: any) =>  {
    setOpen(false)
  }
  function handleModalInputChange(e: string): void {
    setSelectedUser(e);
  }
  const column : TableProps<Employee>['columns']  = [
      {
          title: "S/N",
          dataIndex: "index",
          key: "index",
          render: (text: string, record: Employee, index: number) =>
          `${index + 1}.`,
          width:'15%'
      },
      {
        title: 'Name',
        dataIndex: 'fullName',
        key: 'fullName',
        render:(text)=> <a >{text}</a>,
        width: '20%',
      },
      {
        title: 'User ID/Email ID',
        dataIndex: 'emailAddress',
        key: 'emailAddress',
        align: 'center',
        width: '20%',
      },
      {
        title: 'PhoneExt',
        dataIndex: 'phoneExt',
        key: 'phoneExt',
        width: '15%',
      },
      
      {
        title: 'Department',
        dataIndex: 'deptName',
        key: 'deptName',
        width: '20%',
      },
      {
        title: 'Location',
        dataIndex: 'locationName',
        key: 'locationName',
        width: '20%',
      },
    ];
    const columns = [
      {
        title: "S/N",
        dataIndex: "key",
        key: "key",
        render: (_: any, __: any, index: number) => index + 1,
      },
      {
        title: "* Account Name",
        dataIndex: "accountName",
        key: "accountName",
        render: (_: any, record: AccRequestData) => (
          <Input
            value={accountName.map((subsidiary) => subsidiary.object === subsidiary.object ? subsidiary.objDescription : "")}
            style={{
              width: "250px",
            }}
            disabled
          />
        ),
      },
      {
        title: "* Business Unit",
        dataIndex: "businessUnit",
        key: "businessUnit",
        render: (_: any, record: AccRequestData, index: number) => (
          <>  
        <Input value={companyCode.locationCode} 
          disabled
          style={{ width: "100px" }}/>
          <Input
            placeholder="Enter Business Unit"
            value={record.businessUnit}
            maxLength={6} // Restrict input to 6 characters
            required={true}
            style={{ width: "100px" }} // Reduce the width of the input field
            onChange={(e) => {
              const newUnits = [...accountrequests];
              newUnits[index].businessUnit = e.target.value;
              setAccountRequest(newUnits);
            } } /></>
          ),
        },
        {
          title: "* Object",
          dataIndex: "object",
          key: "object",
          render: (_: any, record: AccRequestData, index: number) => (
            <AutoComplete
              value={record.object} // Bind the selected value to the state
              onSearch={(searchText: string) => {
                // Filter dropdown options based on search input
                const filteredOptions = autoCompleteOptions.filter((option) =>
                  option.value.toLowerCase().includes(searchText.toLowerCase())
                );
                setFilteredObjectOptions(filteredOptions); // Update filtered options
              }}
              onSelect={(value: string) => {
                // Update the state when an option is selected
                onSelectedSubsidiaryChange(value);
                const updatedRecords = [...accountrequests];
                updatedRecords[index].object = value;
                setAccountRequest(updatedRecords);
              }}
              onChange={(value: string) => {
                // Update the state when the input value changes
                
                
                const updatedRecords = [...accountrequests];
                updatedRecords[index].object = value;
                setAccountRequest(updatedRecords);
              }}
              placeholder="Enter or Search Object"
              style={{ width: "160px" }}
              notFoundContent={
                record.object && filteredObjectOptions.length === 0
                  ? "No match found, please rephrase search"
                  : null
              }
            >
              {filteredObjectOptions.map(item => {
                                const parts = item.value.split('-');
                                const objectId = parts[0].trim();
                                const description = parts.length > 1 ? parts[1].trim() : '';
                               
                                return (
                                  <AutoComplete.Option key={item.key} value={objectId}>
                                  {objectId} - {description}
                                  </AutoComplete.Option>
                                );
                              })}
            </AutoComplete>
          ),
        },
    {
      title: "* Subsidiary",
      dataIndex: "subsidiary",
      key: "subsidiary",
      render: (_: any, record: AccRequestData, index: number) => (
        <Select
          value={record.subsidiary} // Bind the selected value to the state
          onChange={(value: string) => {
            handleSubsidiaryChange(value,index); // Call the handler to fetch related data
          }}
          style={{ width: "160px", textTransform: "uppercase" }}
        >
          <Select.Option value={null}> </Select.Option> {/* Null option */}
          {subsidiaries.map((map) => (
            <Select.Option key={map.object} value={map.subsidiary}>
              {`${map.subsidiary} - ${map.objDescription}`}
            </Select.Option>
          ))}
        </Select>
      ),
    },
  ];

  const handleSubsidiaryChange = (value: string, index: number) => {
    setLoading(true);
    const selectedSubsidiary = subsidiaries.find((sub) => sub.subsidiary === value);
    const updatedRequests = [...accountrequests];
    if (selectedSubsidiary) {
      updatedRequests[index].subsidiary = value;
      updatedRequests[index].objDescription = selectedSubsidiary.objDescription;
    }
    setLoading(false);
    setAccountRequest(updatedRequests);
    setAccountName(updatedRequests);
  };
  const handleObjectChange = async (e: any) => {
    setLoading(true);
    try {
      const response = await FetchSubsidiariesByObject(e);
      setSubsidiaries(response);
      appInsights.trackEvent({ name: "Fetch Subsidiaries By Object Success", properties: { userId: user.email, object: e } });
    }
    catch (error) {
      setApiError(error);
      message.error("Failed to fetch Subsidiaries By Object");
      appInsights.trackException({ exception: error as Error, properties: { Component: 'AccountRequest', method: 'handleObjectChange', context: 'Fetch Subsidiaries By Object', userId: user.email, object: e } });
    }
    finally {
      setLoading(false);
    }
  };
  const handleRetry = () => {
    setApiError(null);
  };
  return (
    <>
     {apiError ? (
               <GlobalErrorMessage 
               error={apiError}
               visible={!!apiError}
               onClose={() => setApiError(null)}
               onRetry={handleRetry}
             />
             ) : (
    <Spin spinning={loading}>
             <div>
            <p>Notes:</p>
            <p>1. This Form can be used to Add/Change Accounts</p>
            <p> 2. * marked fields are required  </p>
          </div><div className="site-layout-content">
              <div className="div-container">
                <Tabs defaultActiveKey="1"
                  activeKey={currentTab.toString()}
                  onChange={(key) => setCurrentTab(Number(key))}>
                  <TabPane tab="Account Request" key="1">
                    <Title
                      level={4}
                      style={{ textAlign: "left", marginBottom: "20px" }}
                    >
                      Account Request Details
                    </Title>
                    <Form form={formrequest} onFinish={handleFinish}>
                      <Row gutter={16}>
                        <Col span={12}>
                          <Form.Item
                            label="Requester"
                            name="requester"
                            labelCol={{ span: 8 }}
                            wrapperCol={{ span: 16 }}
                          >
                            <Input
                              placeholder={requester}
                              value={requester}
                              disabled />
                            {/* <Input value={contextUser.email} disabled /> */}
                          </Form.Item>
                        </Col>
                        <Col span={12}>
                          <Form.Item
                            label="Date"
                            name="date"
                            labelCol={{ span: 8 }}
                            wrapperCol={{ span: 16 }}
                          >
                            <Input
                              value={requestDate}
                              placeholder={requestDate}
                              disabled />
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row gutter={16}>
                        <Col span={12}>
                          <Form.Item
                            label="Action Code"
                            name="actionCode"
                            rules={[{ required: true }]}
                            labelCol={{ span: 8 }}
                            wrapperCol={{ span: 16 }}
                            initialValue="A"
                          >
                            <Select value={actionCode} onChange={(value) => setActionCode(value)}>
                              <Option value="A">A - Add</Option>
                              <Option value="U">U - Update</Option>
                              <Option value="D">D - Deactivate</Option>
                            </Select>
                          </Form.Item>
                        </Col>
                        <Col span={12}>
                          <Form.Item
                            label="Company"
                            name="company"
                            rules={[{ required: true }]}
                            labelCol={{ span: 8 }}
                            wrapperCol={{ span: 16 }}
                          >
                            <Select value={company} onChange={setCompany}
                              onSelect={(e) => SetCompanyCode(e)}>
                              <option value=""></option>
                              {companyCodes.map((option) => (
                                <option key={option.ccco} value={option.ccco}>
                                  {option.cccO_NAME}
                                </option>
                              ))}
                            </Select>
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row gutter={16}>
                        <Col span={12}>
                          <Form.Item
                            label="Reason for request"
                            name="reason"
                            rules={[{ required: true }]}
                            labelCol={{ span: 8 }}
                            wrapperCol={{ span: 16 }}
                          >
                            <Input.TextArea
                              value={reason}
                              onChange={(e) => setReason(e.target.value)}
                              maxLength={499} />
                          </Form.Item>
                        </Col>
                        <Col span={12}>
                          <Form.Item
                            label="Posting Edit"
                            name="postingEdit"
                            labelCol={{ span: 8 }}
                            wrapperCol={{ span: 16 }}
                          >
                            <Select value={postEdit} onChange={setPostEdit}>
                              <option value=""></option>
                              <option value="N">N</option>
                            </Select>
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row gutter={16}>
                        <Col span={12}>
                          <Form.Item
                            label="Unit of Measure"
                            name="UnitMeasureType"
                            labelCol={{ span: 8 }}
                            wrapperCol={{ span: 16 }}
                          >
                            <Select value={AccType} onChange={setAccType}>
                            <option value=""></option>
                              {Acc.map((option) => (
                                <option key={option.drky} value={option.drky}>
                                  {option.drkY_DL01}
                                </option>
                              ))}
                            </Select>
                          </Form.Item>
                        </Col>
                        <Col span={12}>
                          <Form.Item
                            label={<span style={{ whiteSpace: "normal" }}>
                              Number of Business <br />
                              Units being Modified
                            </span>}
                            name="businessUnitsModified"
                            labelCol={{ span: 8 }}
                            wrapperCol={{ span: 16 }}
                            initialValue={1}
                          >
                            <Select
                              value={buModified}
                              onChange={(value) => handleChange(value)}
                            >
                              {buModifiedOptions}
                            </Select>
                          </Form.Item>
                        </Col>
                      </Row>
                      <Divider>Business Units</Divider>
                      <Table
                        dataSource={accountrequests}
                        columns={columns}
                        pagination={false}
                        bordered
                        rowKey="key" // Use the "key" property as the unique identifier
                      />
                      <Divider>Attachments</Divider>
                      <Row gutter={16}>
                        <Col span={12}>
                          <span>Attachments</span>
                          <Form.Item
                            labelCol={{ span: 8 }}
                            wrapperCol={{ span: 16 }}
                          >
                            <Input type="file" onChange={handleFileChange1}></Input>
                            <Input type="file" onChange={handleFileChange2}></Input>
                            <Input type="file" onChange={handleFileChange3}></Input>
                          </Form.Item>
                        </Col>
                        <Col span={6}>
                          <span>Attach any files that are relevant to this request.</span>
                        </Col>
                      </Row>
                      <Row gutter={16} style={{ marginLeft: "380px" }}>
                        <Col span={24}>
                          <Form.Item>
                            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                              <Button onClick={handleCancel}>Cancel</Button>
                              <Button onClick={handleBack} disabled={currentTab === 1}>
                                Back
                              </Button>
                              <div>
                                Step <Typography.Text strong>{currentTab}</Typography.Text> of <Typography.Text strong>{totalSteps}</Typography.Text>
                              </div>
                              <Button
                                onClick={handleNext}
                                disabled={currentTab === 5 ||
                                  (currentTab === 1 && (
                                    !actionCode ||
                                    !company.toString() ||
                                    !reason ||
                                    companyCode.locationCode == 0 ||
                                    accountrequests.some((unit) => !unit.businessUnit) ||
                                    accountrequests.some((unit) => !unit.object) ||
                                    accountrequests.some((unit) => !unit.subsidiary) ||
                                    accountName.some((unit) => !unit.objDescription)
                                  ))}
                              >
                                Next
                              </Button>
                              <Button onClick={handleFinish} disabled={currentTab !== 5}>Finish</Button>
                            </div>
                          </Form.Item>
                        </Col>
                      </Row>
                    </Form>
                  </TabPane>
                  <TabPane tab="Cat Codes 1 - 10" key="2"
                   disabled={
                    !actionCode ||
                    !company.toString() ||
                    !reason ||
                    companyCode.locationCode === 0 ||
                    accountrequests.some((unit) => !unit.businessUnit) ||
                    accountrequests.some((unit) => !unit.object) ||
                    accountrequests.some((unit) => !unit.subsidiary) ||
                    accountName.some((unit) => !unit.objDescription)
                  }>
                    <div className="panel pnl-repCodes step-2" id="tb-reportCodes-1-10">
                      <Title level={3}>Category Codes 1 - 10</Title>
                      <Form form={formrequest} onFinish={handleFinish} layout="vertical">
                        <Row gutter={[16, 16]}>
                          <Col span={12}>
                            <Form.Item label="JC Processes:" name="jcProcesses">
                              <Select value={jcprocessestype} onChange={setjcprocessestype} style={{ width: "100%" }}>
                              <option value=""></option>
                                {jcprocesses.map((option) => (
                                  <option key={option.drky} value={option.drky}>
                                    {option.drkY_DL01}
                                  </option>
                                ))}
                              </Select>
                            </Form.Item>
                          </Col>
                          <Col span={12}>
                            <Form.Item label="JC Components/Deliv:" name="jcComponents">
                              <Select value={jccomponentstype} onChange={setjccomponentstype} style={{ width: "100%" }}>
                              <option value=""></option>
                                {jccomponents.map((option) => (
                                  <option key={option.drky} value={option.drky}>
                                    {option.drkY_DL01}
                                  </option>
                                ))}
                              </Select>
                            </Form.Item>
                          </Col>
                          <Col span={12}>
                            <Form.Item label="JC DISWin:" name="jcDISWin">
                              <Select value={jcdiswintype} onChange={setjcdiswintype} style={{ width: "100%" }}>
                              <option value=""></option>
                                {jcdiswin.map((option) => (
                                  <option key={option.drky} value={option.drky}>
                                    {option.drkY_DL01}
                                  </option>
                                ))}
                              </Select>
                            </Form.Item>
                          </Col>
                          <Col span={12}>
                            <Form.Item label="JC Intangible/Tangible:" name="jcIntangibleTangible">
                              <Select value={jcintangibletype} onChange={setjcintangibletype} style={{ width: "100%" }}>
                              <option value=""></option>
                                {jcintangible.map((option) => (
                                  <option key={option.drky} value={option.drky}>
                                    {option.drkY_DL01}
                                  </option>
                                ))}
                              </Select>
                            </Form.Item>
                          </Col>
                          <Col span={12}>
                            <Form.Item label="Interface Control 1:" name="interfaceControl1">
                              <Select value={interfaceControl1TYpe} onChange={setinterfaceControl1TYpe} style={{ width: "100%" }}>
                              <option value=""></option>
                                {interfaceControl1.map((option) => (
                                  <option key={option.drky} value={option.drky}>
                                    {option.drkY_DL01}
                                  </option>
                                ))}
                              </Select>
                            </Form.Item>
                          </Col>
                          <Col span={12}>
                            <Form.Item label="Interface Control 2:" name="interfaceControl2">
                              <Select value={interfaceControl2Type} onChange={setinterfaceControl2Type} style={{ width: "100%" }}>
                              <option value=""></option>
                                {interfaceControl2.map((option) => (
                                  <option key={option.drky} value={option.drky}>
                                    {option.drkY_DL01}
                                  </option>
                                ))}
                              </Select>
                            </Form.Item>
                          </Col>
                          <Col span={12}>
                            <Form.Item label="Management Report 2:" name="managementReport2">
                              <Select value={management2Type} onChange={setmanagment2Type} style={{ width: "100%" }}>
                              <option value=""></option>
                                {management2.map((option) => (
                                  <option key={option.drky} value={option.drky}>
                                    {option.drkY_DL01}
                                  </option>
                                ))}
                              </Select>
                            </Form.Item>
                          </Col>
                          <Col span={12}>
                            <Form.Item label="Management Report 3:" name="managementReport3">
                              <Select value={management3Type} onChange={setmanagment3Type} style={{ width: "100%" }}>
                              <option value=""></option>
                                {management3.map((option) => (
                                  <option key={option.drky} value={option.drky}>
                                    {option.drkY_DL01}
                                  </option>
                                ))}
                              </Select>
                            </Form.Item>
                          </Col>
                          <Col span={12}>
                            <Form.Item label="GA Reporting 1:" name="gaReporting1">
                              <Select value={gareportingtype} onChange={setgareportingtype} style={{ width: "100%" }}>
                              <option value=""></option>
                                {gareporting.map((option) => (
                                  <option key={option.drky} value={option.drky}>
                                    {option.drkY_DL01}
                                  </option>
                                ))}
                              </Select>
                            </Form.Item>
                          </Col>
                          <Col span={12}>
                            <Form.Item label="JV Posting Edit Contr:" name="jvPostingEditContr">
                              <Select value={jvpostingtype} onChange={setjvpostingtype} style={{ width: "100%" }}>
                              <option value=""></option>
                                {jvposting.map((option) => (
                                  <option key={option.drky} value={option.drky}>
                                    {option.drkY_DL01}
                                  </option>
                                ))}
                              </Select>
                            </Form.Item>
                          </Col>
                        </Row>
                        <Row gutter={16} style={{ marginLeft: "380px" }}>
                          <Col span={24}>
                            <Form.Item>
                              <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                <Button onClick={handleCancel}>Cancel</Button>
                                <Button onClick={handleBack} disabled={currentTab === 1}>
                                  Back
                                </Button>
                                <div>
                                  Step <Typography.Text strong>{currentTab}</Typography.Text> of <Typography.Text strong>{totalSteps}</Typography.Text>
                                </div>
                                <Button onClick={handleNext} disabled={currentTab === 5}>
                                  Next
                                </Button>
                                <Button onClick={handleFinish} disabled={currentTab !== 5}>
                                  Finish</Button>
                              </div>
                            </Form.Item>
                          </Col>
                        </Row>
                      </Form>
                    </div>
                  </TabPane>
                  <TabPane tab="Cat Codes 11 - 20" key="3"
                    disabled={
                      !actionCode ||
                      !company.toString() ||
                      !reason ||
                      companyCode.locationCode === 0 ||
                      accountrequests.some((unit) => !unit.businessUnit) ||
                      accountrequests.some((unit) => !unit.object) ||
                      accountrequests.some((unit) => !unit.subsidiary) ||
                      accountName.some((unit) => !unit.objDescription) ||
                      !currencytype
                    }>
                    <div className="panel pnl-repCodes step-3" id="tb-reportCodes-11-20">
                      <Title level={3}>Category Codes 11 - 20</Title>
                      <Form form={formrequest} onFinish={handleFinish} layout="vertical">
                        <Row gutter={16}>
                          <Col span={12}>
                            <Form.Item label="JV Chargeability:" name="ddlJVChrgCode">
                              <Select value={jvChargeabilityType} onChange={setjvChargeabilityType} style={{ width: '100%' }}>
                              <option value=""></option>
                                {jvChargeability.map((option) => (
                                  <option key={option.drky} value={option.drky}>
                                    {option.drkY_DL01}
                                  </option>
                                ))}
                              </Select>
                            </Form.Item>
                          </Col>
                          <Col span={12}>
                            <Form.Item label="JV Division of Interest:" name="ddlJVPartCode">
                              <Select value={divisionType} onChange={setdivisionType} style={{ width: '100%' }}>
                              <option value=""></option>
                                {division.map((option) => (
                                  <option key={option.drky} value={option.drky}>
                                    {option.drkY_DL01}
                                  </option>
                                ))}
                              </Select>
                            </Form.Item>
                          </Col>
                          <Col span={12}>
                            <Form.Item label="Partner Requirement 4:" name="ddlC13RptCode">
                              <Select value={partnertype} onChange={setpartnertype} style={{ width: '100%' }}>
                              <option value=""></option>
                                {partner.map((option) => (
                                  <option key={option.drky} value={option.drky}>
                                    {option.drkY_DL01}
                                  </option>
                                ))}
                              </Select>
                            </Form.Item>
                          </Col>
                          <Col span={12}>
                            <Form.Item label="Management Report 1:" name="ddlOpexRptCod">
                              <Select value={management1type} onChange={setmanagement1type} style={{ width: '100%' }}>
                              <option value=""></option>
                                {management1.map((option) => (
                                  <option key={option.drky} value={option.drky}>
                                    {option.drkY_DL01}
                                  </option>
                                ))}
                              </Select>
                            </Form.Item>
                          </Col>
                          <Col span={12}>
                            <Form.Item label="JDE Localization:" name="ddlExpendType">
                              <Select value={Localization1Type} onChange={setLocalization1Type} style={{ width: '100%' }}>
                              <option value=""></option>
                                {Localization1.map((option) => (
                                  <option key={option.drky} value={option.drky}>
                                    {option.drkY_DL01}
                                  </option>
                                ))}
                              </Select>
                            </Form.Item>
                          </Col>
                          <Col span={12}>
                            <Form.Item label="Currency Restate 1:" name="ddlReconWkGrp" required>
                              <Select value={currencytype} onChange={setcurrencytype} style={{ width: '100%' }}>
                              <option value=""></option>
                                {currency.map((option) => (
                                  <option key={option.drky} value={option.drky}>
                                    {option.drkY_DL01}
                                  </option>
                                ))}
                              </Select>
                            </Form.Item>
                          </Col>
                          <Col span={12}>
                            <Form.Item label="Currency Restate 2:" name="ddlMgtProfit">
                              <Select value={currencyrestate2type} onChange={setcurrencyrestate2type} style={{ width: '100%' }}>
                              <option value=""></option>
                                {currencyrestate2.map((option) => (
                                  <option key={option.drky} value={option.drky}>
                                    {option.drkY_DL01}
                                  </option>
                                ))}
                              </Select>
                            </Form.Item>
                          </Col>
                          <Col span={12}>
                            <Form.Item label="Currency Restate 3:" name="ddlCurrencies">
                              <Select value={currencyrestate3type} onChange={setcurrencyrestate3type} style={{ width: '100%' }}>
                              <option value=""></option>
                                {currencyrestate3.map((option) => (
                                  <option key={option.drky} value={option.drky}>
                                    {option.drkY_DL01}
                                  </option>
                                ))}
                              </Select>
                            </Form.Item>
                          </Col>
                          <Col span={12}>
                            <Form.Item label="JDE Localization 2:" name="ddlC19RptCode">
                              <Select value={Localization2Type} onChange={setLocalization2Type} style={{ width: '100%' }}>
                              <option value=""></option>
                                {Localization2.map((option) => (
                                  <option key={option.drky} value={option.drky}>
                                    {option.drkY_DL01}
                                  </option>
                                ))}
                              </Select>
                            </Form.Item>
                          </Col>
                          <Col span={12}>
                            <Form.Item label="JDE Localization 3:" name="ddlC20RptCode">
                              <Select value={Localization3Type} onChange={setLocalization3Type} style={{ width: '100%' }}>
                              <option value=""></option>
                                {Localization3.map((option) => (
                                  <option key={option.drky} value={option.drky}>
                                    {option.drkY_DL01}
                                  </option>
                                ))}
                              </Select>
                            </Form.Item>
                          </Col>
                        </Row>
                        <Row gutter={16} style={{ marginLeft: "380px" }}>
                          <Col span={24}>
                            <Form.Item>
                              <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                <Button onClick={handleCancel}>Cancel</Button>
                                <Button onClick={handleBack} disabled={currentTab === 1}>
                                  Back
                                </Button>
                                <div>
                                  Step <Typography.Text strong>{currentTab}</Typography.Text> of <Typography.Text strong>{totalSteps}</Typography.Text>
                                </div>
                                <Button onClick={handleNext}
                                  disabled={currentTab === 5 ||
                                    (currentTab === 3 && (!currencytype))}>
                                  Next
                                </Button>
                                <Button onClick={handleFinish} disabled={currentTab !== 5}>Finish</Button>
                              </div>
                            </Form.Item>
                          </Col>
                        </Row>
                      </Form>
                    </div>
                  </TabPane>
                  <TabPane tab="Cat Codes 21 - 30" key="4"
                   disabled={
                    !actionCode ||
                    !company.toString() ||
                    !reason ||
                    companyCode.locationCode === 0 ||
                    accountrequests.some((unit) => !unit.businessUnit) ||
                    accountrequests.some((unit) => !unit.object) ||
                    accountrequests.some((unit) => !unit.subsidiary) ||
                    accountName.some((unit) => !unit.objDescription) ||
                    !currencytype
                  }>
                    <div className="panel pnl-repCodes step-4" id="tb-reportCodes-21-30">
                      <Title level={3}>Category Codes 21 - 30</Title>
                      <Form layout="vertical">
                        <Row gutter={[16, 16]}>
                          <Col span={12}>
                            <Form.Item label="Alternate Account:" name="alternateAccount">
                              <Select value={Alternatetype} onChange={setAlternatetype} style={{ width: '100%' }}>
                              <option value=""></option>
                                {Alternate.map((option) => (
                                  <option key={option.drky} value={option.drky}>
                                    {option.drkY_DL01}
                                  </option>
                                ))}
                              </Select>
                            </Form.Item>
                          </Col>
                          <Col span={12}>
                            <Form.Item label="Ariba Interface Flag:" name="aribaInterfaceFlag">
                              <Select value={Aribatype} onChange={setAribatype} style={{ width: '100%' }}>
                              <option value=""></option>
                                {Ariba.map((option) => (
                                  <option key={option.drky} value={option.drky}>
                                    {option.drkY_DL01}
                                  </option>
                                ))}
                              </Select>
                            </Form.Item>
                          </Col>
                          <Col span={12}>
                            <Form.Item label="SAP Asset Class:" name="sapAssetClass">
                              <Select value={SAPtype} onChange={setSAPtype} style={{ width: '100%' }}>
                              <option value=""></option>
                                {SAP.map((option) => (
                                  <option key={option.drky} value={option.drky}>
                                    {option.drkY_DL01}
                                  </option>
                                ))}
                              </Select>
                            </Form.Item>
                          </Col>
                          <Col span={12}>
                            <Form.Item label="Tax 1:" name="tax1">
                              <Select value={Tax1type} onChange={setTax1type} style={{ width: '100%' }}>
                              <option value=""></option>
                                {Tax1.map((option) => (
                                  <option key={option.drky} value={option.drky}>
                                    {option.drkY_DL01}
                                  </option>
                                ))}
                              </Select>
                            </Form.Item>
                          </Col>
                          <Col span={12}>
                            <Form.Item label="Tax 2:" name="tax2">
                              <Select value={Tax2type} onChange={setTax2type} style={{ width: '100%' }}>
                              <option value=""></option>
                                {Tax2.map((option) => (
                                  <option key={option.drky} value={option.drky}>
                                    {option.drkY_DL01}
                                  </option>
                                ))}
                              </Select>
                            </Form.Item>
                          </Col>
                          <Col span={12}>
                            <Form.Item label="Tax 3:" name="tax3">
                              <Select value={Tax3type} onChange={setTax3type} style={{ width: '100%' }}>
                              <option value=""></option>
                                {Tax3.map((option) => (
                                  <option key={option.drky} value={option.drky}>
                                    {option.drkY_DL01}
                                  </option>
                                ))}
                              </Select>
                            </Form.Item>
                          </Col>
                          <Col span={12}>
                            <Form.Item label="PSC Code:" name="pscCode">
                              <Select value={psccodetype} onChange={setpsccodetype} style={{ width: '100%' }}>
                              <option value=""></option>
                                {psccode.map((option) => (
                                  <option key={option.drky} value={option.drky}>
                                    {option.drkY_DL01}
                                  </option>
                                ))}
                              </Select>
                            </Form.Item>
                          </Col>
                          <Col span={12}>
                            <Form.Item label="Recon Frequency:" name="reconFrequency">
                              <Select value={Recontype} onChange={setRecontype} style={{ width: '100%' }}>
                              <option value=""></option>
                                {Recon.map((option) => (
                                  <option key={option.drky} value={option.drky}>
                                    {option.drkY_DL01}
                                  </option>
                                ))}
                              </Select>
                            </Form.Item>
                          </Col>
                          <Col span={12}>
                            <Form.Item label="Recon Responsible:" name="reconResponsible">
                              <Select value={ReconRestype} onChange={setReconRestype} style={{ width: '100%' }}>
                              <option value=""></option>
                                {ReconRes.map((option) => (
                                  <option key={option.drky} value={option.drky}>
                                    {option.drkY_DL01}
                                  </option>
                                ))}
                              </Select>
                            </Form.Item>
                          </Col>
                          <Col span={12}>
                            <Form.Item label="Partner Requirement 1:" name="partnerRequirement1">
                              <Select value={PartnerReqtype} onChange={setPartnerReqtype} style={{ width: '100%' }}>
                              <option value=""></option>
                                {PartnerReq.map((option) => (
                                  <option key={option.drky} value={option.drky}>
                                    {option.drkY_DL01}
                                  </option>
                                ))}
                              </Select>
                            </Form.Item>
                          </Col>
                        </Row>
                        <Row gutter={16} style={{ marginLeft: "380px" }}>
                          <Col span={24}>
                            <Form.Item>
                              <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                <Button onClick={handleCancel}>Cancel</Button>
                                <Button onClick={handleBack} disabled={currentTab === 1}>
                                  Back
                                </Button>
                                <div>
                                  Step <Typography.Text strong>{currentTab}</Typography.Text> of <Typography.Text strong>{totalSteps}</Typography.Text>
                                </div>
                                <Button onClick={handleNext} disabled={currentTab === 5}>
                                  Next
                                </Button>
                                <Button onClick={ handleFinish} disabled={currentTab !== 5}>  
                                Finish</Button>
                              </div>
                            </Form.Item>
                          </Col>
                        </Row>
                      </Form>
                    </div>
                  </TabPane>
                  <TabPane tab="Reviewing Route" key="5"
                    disabled={
                      !actionCode ||
                      !company.toString() ||
                      !reason ||
                      companyCode.locationCode === 0 ||
                      accountrequests.some((unit) => !unit.businessUnit) ||
                      accountrequests.some((unit) => !unit.object) ||
                      accountrequests.some((unit) => !unit.subsidiary) ||
                      accountName.some((unit) => !unit.objDescription) ||
                      !currencytype
                    }>
                    <div className="reviewing-route">
                      <Title level={3}>Reviewing Route</Title>

                      <Form form={formrapproval} layout="vertical">
                        {/* Approver Email */}
                         <Row>
                                <Col>
                                  <Form.Item     
                                  label="Approver Email ID"
                                      name="approvalemailid"
                                      tooltip="Enter the email address of the approver"
                                      rules={[{ required: true }]}>
                                    </Form.Item>
                                  </Col>
                               <Col style={{ marginLeft: "40px" }}>
                                         <Input
                                                     placeholder="Approval Email ID"
                                                     value={selectedUser|| ""}
                                                     onChange={(e) => setSelectedUser(e.target.value)}
                                                     style={{ width: '200px', marginRight: '10px' }}/>
                                                    <a onClick={() => showModal(selectedUser)}>
                                                    <SearchOutlined />
                                                    </a>
                                                    {selectedRequesterName && (<span style={{ marginLeft: 10 }}> {selectedRequesterName} </span>)}
                                      </Col>
                                </Row>
                        <Row gutter={16}>
                          <Col span={8}>
                            <Form.Item
                              label="Financial Accounting"
                              name="financialAccounting"
                              rules={[{ required: true, message: "Please select an option!" }]}
                            >
                              <Select value={faApproversType} onChange={setfaApproversType}>
                              <option value=""></option>
                                {faApprovers.map((code) => (
                                  <option key={code.emailID} value={code.emailID}>
                                    {code.name}
                                  </option>
                                ))}
                              </Select>
                            </Form.Item>
                          </Col>
                          <Col span={12}>
                            {/* Placeholder for future input */}
                          </Col>
                        </Row>
                        <Row gutter={16}>
                              <Col span={8}>
                              </Col>
                              <Col span={16}>
                                    <Typography.Text type="secondary">* Reasons are needed if Approver is not selected</Typography.Text>
                              </Col>
                        </Row>
                        <Row gutter={16}>
                          <Col span={8}>
                            <Form.Item
                              label="Joint Venture"
                              name="jointVenture"
                            >
                              <Select value={selectedjvApprovers} onChange={setselectedjvApprovers}>
                              <option value=""></option>
                                {jvApprovers.map((code) => (
                                  <option key={code.emailID} value={code.emailID}>
                                    {code.name}
                                  </option>
                                ))}
                              </Select>
                            </Form.Item>
                          </Col>
                          <Col span={16}>
                            <Form.Item label="Joint Venture Details" name="jointVentureDetails">
                              <Input.TextArea
                                value={jvdeatils}
                                onChange={(e) => setjvdeatils(e.target.value)}
                                style={{ textTransform: "uppercase" }} />
                            </Form.Item>
                          </Col>
                        </Row>
                        <Row gutter={16}>
                          <Col span={8}>
                            <Form.Item
                              label="PSC"
                              name="psc"
                            >
                              <Select value={selectedpscApprovers} onChange={setSelectedpscApprovers}>
                              <option value=""></option>
                                {pscApprovers.map((code) => (
                                  <option key={code.emailID} value={code.emailID}>
                                    {code.name}
                                  </option>
                                ))}
                              </Select>
                            </Form.Item>
                          </Col>
                          <Col span={16}>
                            <Form.Item label="PSC Details" name="pscDetails">
                              <Input.TextArea
                                value={pscDetails}
                                onChange={(e) => setpscDetails(e.target.value)}
                                style={{ textTransform: "uppercase" }} />
                            </Form.Item>
                          </Col>
                        </Row>
                        <Row gutter={16}>
                          <Col span={8}>
                            <Form.Item
                              label="Gas"
                              name="gas"
                            >
                              <Select value={selectedgasApprovers} onChange={setselectedgasApprovers}>
                              <option value=""></option>
                                {gasApprovers.map((code) => (
                                  <option key={code.emailID} value={code.emailID}>
                                    {code.name}
                                  </option>
                                ))}
                              </Select>
                            </Form.Item>
                          </Col>
                          <Col span={16}>
                            <Form.Item label="Gas Details" name="gasDetails">
                              <Input.TextArea
                                value={gasDetails}
                                onChange={(e) => setgasDetails(e.target.value)}
                                style={{ textTransform: "uppercase" }} />
                            </Form.Item>
                          </Col>
                        </Row>
                        {/* InterCo Section */}
                        <Row gutter={16}>
                          <Col span={8}>
                            <Form.Item label="InterCo:" name="interCo">
                              <Select value={selectedinterCoApprovers} onChange={setselectedinterCoApprovers}>
                              <option value=""></option>
                                {interCoApprovers.map((code) => (
                                  <option key={code.emailID} value={code.emailID}>
                                    {code.name}
                                  </option>
                                ))}
                              </Select>
                            </Form.Item>
                          </Col>
                          <Col span={16}>
                            <Form.Item label="Details" name="interCoDetails">
                              <Input.TextArea
                                value={interDetails}
                                onChange={(e) => setinterDetails(e.target.value)}
                                style={{ textTransform: "uppercase" }} />
                            </Form.Item>
                          </Col>
                        </Row>
                        {/* Allocation Section */}
                        <Row gutter={16}>
                          <Col span={8}>
                            <Form.Item label="Allocation:" name="allocation">
                              <Select value={selectedallocationapprovers} onChange={setselectedallocationapprovers}>
                              <option value=""></option>
                                {allocationapprovers.map((code) => (
                                  <option key={code.emailID} value={code.emailID}>
                                    {code.name}
                                  </option>
                                ))}
                              </Select>
                            </Form.Item>
                          </Col>
                          <Col span={16}>
                            <Form.Item label="Details" name="allocationDetails">
                              <Input.TextArea
                                value={alloDetails}
                                onChange={(e) => setalloDetails(e.target.value)}
                                style={{ textTransform: "uppercase" }} />
                            </Form.Item>
                          </Col>
                        </Row>
                        {/* Fixed Asset Section */}
                        <Row gutter={16}>
                          <Col span={8}>
                            <Form.Item label="Fixed Asset:" name="fixedAsset">
                              <Select value={selectedfixedAssetapprovers} onChange={setselectedfixedAssetapprovers}>
                              <option value=""></option>
                                {fixedAssetapprovers.map((code) => (
                                  <option key={code.emailID} value={code.emailID}>
                                    {code.name}
                                  </option>
                                ))}
                              </Select>
                            </Form.Item>
                          </Col>
                          <Col span={16}>
                            <Form.Item label="Details" name="fixedAssetDetails">
                              <Input.TextArea
                                value={fixDetails}
                                onChange={(e) => setfixDetails(e.target.value)}
                                style={{ textTransform: "uppercase" }} />
                            </Form.Item>
                          </Col>
                        </Row>
                        {/* Production Accounting Section */}
                        <Row gutter={16}>
                          <Col span={8}>
                            <Form.Item
                              label="Production Accounting:"
                              name="productionAccounting"
                            >
                              <Select value={selectedproductionAccountingapprovers} onChange={setselectedproductionAccountingapprovers}>
                              <option value=""></option>
                                {productionAccountingapprovers.map((code) => (
                                  <option key={code.emailID} value={code.emailID}>
                                    {code.name}
                                  </option>
                                ))}
                              </Select>
                            </Form.Item>
                          </Col>
                          <Col span={16}>
                            <Form.Item label="Details" name="productionAccountingDetails">
                              <Input.TextArea
                                value={prodDetails}
                                onChange={(e) => setprodDetails(e.target.value)}
                                style={{ textTransform: "uppercase" }} />
                            </Form.Item>
                          </Col>
                        </Row>
                        {/* Hidden Fields */}
                        <Form.Item name="bpc" hidden>
                          <Input />
                        </Form.Item>
                        <Form.Item name="bpcDetails" hidden>
                          <Input.TextArea
                            value={bpcDetails}
                            onChange={(e) => setbpcDetails(e.target.value)}
                            style={{ textTransform: "uppercase" }} />
                        </Form.Item>
                        <Row gutter={16} style={{ marginLeft: "380px" }}>
                          <Col span={24}>
                            <Form.Item>
                              <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                <Button onClick={handleCancel}>Cancel</Button>
                                <Button onClick={handleBack} disabled={currentTab === 1}>
                                  Back
                                </Button>
                                <div>
                                  Step <Typography.Text strong>{currentTab}</Typography.Text> of <Typography.Text strong>{totalSteps}</Typography.Text>
                                </div>
                                <Button onClick={handleNext} disabled={currentTab === 5}>
                                  Next
                                </Button>
                                <Button onClick={handleFinish}
                                   disabled={currentTab !== 5 ||
                                    (currentTab === 5 && (
                                      !selectedUser ||
                                      !faApproversType || 
                                      (selectedjvApprovers === "" && jvdeatils === "") ||
                                      (selectedpscApprovers === "" && pscDetails === "") ||
                                      (selectedgasApprovers === "" && gasDetails === "") ||
                                      (selectedinterCoApprovers === "" && interDetails === "") ||
                                      (selectedallocationapprovers === "" && alloDetails === "") ||
                                      (selectedfixedAssetapprovers === "" && fixDetails === "") ||
                                      (selectedproductionAccountingapprovers === "" && prodDetails === "") ||      
                                      !actionCode ||
                                      !company.toString() ||
                                      !reason ||
                                      companyCode.locationCode == 0 ||
                                      accountrequests.some((unit) => !unit.businessUnit) ||
                                      accountrequests.some((unit) => !unit.object) ||
                                      accountrequests.some((unit) => !unit.subsidiary) ||
                                      accountName.some((unit) => !unit.objDescription) ||
                                      !currencytype
                                    ))
                                  }
                                >Finish</Button>
                              </div>
                            </Form.Item>
                          </Col>
                        </Row>
                      </Form>
                    </div>

                  </TabPane>
                </Tabs>
              </div>
            </div><div style={{ marginTop: "20px" }}>
              <Modal
                open={issucess}
                onCancel={handleclose}
                footer={null}
              >
                <Title level={4}>Operation Sucessfull!</Title>
                <Typography.Text>Account Request {aCCApprovalResponse.requestID} has been successfully created.</Typography.Text>
                <br />
                <Typography.Text>The window will now exit this page.</Typography.Text>
              </Modal>
            </div>
             <div style={{ marginTop: "20px" }}>
                <Modal
                    title="accreqnew-dev.azure.chevron.com says"
                    open={isModalVisible}
                    onOk={handleok}
                    onCancel={handlecancel}
                  >
                    <p>This would return you to the Default page. The data entered has not been saved, and will be lost if you continue!'</p>
                    <p>Click "Cancel" to return and continue this reqest, or click "OK" to discard data and return to Default page.</p>
                  </Modal>
                  </div>
            <div style={{ marginTop: "20px" }}>
              <Modal 
                    open={isHelpVisible}
                    footer={null}
                    closable={false} 
                    afterOpenChange={(visible) => {
                      if (visible) {
                        setTimeout(() => {
                          setIsHelpVisible(false);
                        }, 5000);
                      }
                    }}
                    >
                      <Title level={4}>Having Issues Completing this Form?</Title>
                      <List
                        dataSource={[
                          "You have to complete all required fields to move on to the next step.",
                          "You cannot finish a request if any of the steps is incomplete.",
                          "For content assistance, please contact John-Bosco Ogbuehi (jxxa@chevron.com) on Ext: 69813.",
                        ]}
                        renderItem={(item) => <List.Item>{item}</List.Item>}
                      />
                    </Modal>
            </div>
            <Modal
                   title="Search For Employee"
                   open={open}
                   onOk={handleOk}
                   onCancel={handleempCancel}
                   width={1000}
                   >
                       <Divider></Divider>
                       <Space direction="vertical">
                       <Row gutter={[16,32]} >
                           <Col span={16}>
                               <div>Enter Search Query</div>
                          </Col>
                       </Row>
                       <Row gutter={[16,32]}>
                           <Col span={18}>
                               <div >
                               <Input value={selectedUser|| ""} onChange={(e) => handleModalInputChange(e.target.value)}/>
                               </div>
                           </Col>
                           <Col span={6}>
                               <div >
                               <Button type="primary" onClick={()=>SearchUser(selectedUser)}>Search</Button>
                               </div>
                           </Col>
                       </Row>
                            
                       </Space>
                       
                       <Table
                           dataSource={empData}
                           columns={column}
                           pagination={false}
                           scroll={{ y: 150 }}
                           loading={loading}
                           locale={{ emptyText: 'No matching record found. Kindly refine your criteria!' }}
                           onRow={(record) => ({
                               onClick: () => setRequesters(record.emailAddress),
                             })}
                           style={{marginTop: '20px'}}
                           size='small'
                           />
           
                       <Divider></Divider>
                 </Modal>
    </Spin>
  )}
  </>
  );
};
export default AccRequest;
